exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".langs_div_class[data-v-923cdf5e] {\n  height: 25px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  position: relative;\n}\n.langs_div_class .langs_select_class[data-v-923cdf5e] {\n  width: 100px;\n  color: #989191;\n  border: 1px solid #F1F1F0;\n  border-radius: 5px;\n  outline: none;\n}\n@media screen and (max-width: 768px) {\n.langs_select_class[data-v-923cdf5e] {\n    margin: auto;\n}\n}", ""]);

// exports
